import { settlementsApi } from './config/delfarApi';
import { CustomerPastProductDto, GetSettlementResponseDto } from './dto/settlements.dto';

export const getSettlement = async (orderId: string): Promise<GetSettlementResponseDto> =>
    settlementsApi.get<GetSettlementResponseDto>(`${orderId}`).then((r) => r.data);

export const exportSettlementsCSV = async (): Promise<Blob> =>
    settlementsApi.post('export', {}).then((r) => new Blob([r.data], { type: 'text/csv' }));

export const getCustomerPastProducts = async (orderId: string): Promise<CustomerPastProductDto[]> =>
    settlementsApi
        .get<CustomerPastProductDto[]>(`customer-past-products/${orderId}`)
        .then((r) => r.data);
